module.exports = __webpack_public_path__ + "img/甜杏仁.0d608e33.jpg";